import { Injectable } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { firstValueFrom } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { Group } from '../../../../../models/Group';

@Injectable({
  providedIn: 'root'
})
export class GroupService {

  constructor(private afFun: AngularFireFunctions) { }

  async deleteGroup(groupId: string): Promise<any> {
    return await firstValueFrom(
      this.afFun.httpsCallable('groupFunctions')({
        action: 'DELETE_GROUP',
        groupId: groupId,
      })
    );
  }

  async saveGroup(group: Group, userId: string | null) {
    return await firstValueFrom(
      this.afFun.httpsCallable('groupFunctions')({
        action: 'SAVE_GROUP',
        group: group,
        userId: userId
      })
    );
  }

  async saveGroupJoinSession(groupId: string, joinCode: string) {
    return await firstValueFrom(
      this.afFun.httpsCallable('groupFunctions')({
        action: 'JOIN_SESSION_GROUP',
        groupId: groupId,
        joinCode: joinCode
      })
    );
  }

  async clearGroupJoinCode(groupId: string) {
    return await firstValueFrom(
      this.afFun.httpsCallable('groupFunctions')({
        action: 'CLEAR_JOIN_SESSION_GROUP',
        groupId: groupId,
        joinCode: null
      })
    );
  }

  async removeStudentFromGroup(studentId: string, groupId: string) {
    return await firstValueFrom(
      this.afFun.httpsCallable('groupFunctions')({
        action: 'REMOVE_STUDENT_FROM_GROUP',
        studentId: studentId,
        groupId: groupId
      })
    );
  }
}
